
import React, { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { SkillsHeader } from "./SkillsHeader";
import { SkillsProgressChart } from "./SkillsProgressChart";
import { SkillsFilters } from "./SkillsFilters";
import { SkillsList } from "./SkillsList";
import { AssessmentDialog } from "./AssessmentDialog";
import { skills, progressData, categories, difficulties } from "./skillsData";
import { motion } from "framer-motion";

const SkillsTest = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>("All");
  const [selectedDifficulty, setSelectedDifficulty] = useState<string>("All");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState<string>("");
  const { toast } = useToast();

  const filteredSkills = skills
    .filter(skill => selectedCategory === "All" ? true : skill.category === selectedCategory)
    .filter(skill => selectedDifficulty === "All" ? true : skill.difficulty === selectedDifficulty);

  const handleStartAssessment = (skillName: string) => {
    setSelectedSkill(skillName);
    setDialogOpen(true);
  };

  const handleViewCertificates = () => {
    toast({
      title: "Certificates",
      description: "Viewing your earned certificates",
    });
  };

  const handleStartTest = () => {
    setDialogOpen(false);
    toast({
      title: "Assessment Started",
      description: `Starting ${selectedSkill} assessment. Good luck!`,
    });
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="centered-container py-8">
      <motion.div 
        className="space-y-8"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants} className="bg-white neo-glass rounded-xl p-6 shadow-sm">
          <div className="flex flex-col gap-6">
            <SkillsHeader onViewCertificates={handleViewCertificates} />
            <SkillsProgressChart progressData={progressData} />
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-white neo-glass rounded-xl p-6 shadow-sm">
          <SkillsFilters
            categories={categories}
            difficulties={difficulties}
            selectedCategory={selectedCategory}
            selectedDifficulty={selectedDifficulty}
            setSelectedCategory={setSelectedCategory}
            setSelectedDifficulty={setSelectedDifficulty}
          />
        </motion.div>

        <motion.div variants={itemVariants}>
          <SkillsList 
            filteredSkills={filteredSkills}
            onStartAssessment={handleStartAssessment}
          />
        </motion.div>

        <AssessmentDialog
          isOpen={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onStart={handleStartTest}
          skillName={selectedSkill}
        />
      </motion.div>
    </div>
  );
};

export default SkillsTest;
